import { render, staticRenderFns } from "./ParentFolderPermissions.vue?vue&type=template&id=8d7e6c3e&scoped=true&"
import script from "./ParentFolderPermissions.vue?vue&type=script&lang=js&"
export * from "./ParentFolderPermissions.vue?vue&type=script&lang=js&"
import style0 from "./ParentFolderPermissions.vue?vue&type=style&index=0&id=8d7e6c3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7e6c3e",
  null
  
)

export default component.exports